var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.81,
    y: 1.71,
    width: 236.39,
    height: 146.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.72,
    y1: 143.26,
    x2: 231.28,
    y2: 143.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "131.4 62.51 131.4 33.11 116.95 18.66 31.53 18.48 31.53 142.61 131.4 142.61 131.4 110.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "116.95 18.66 116.95 33.15 131.4 33.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.81,28.31c-10.2,0-18.46,8.27-18.46,18.46h18.46v-18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m66.27,23.69v18.46l16.01,9.17c1.55-2.7,2.45-5.83,2.45-9.17,0-10.2-8.27-18.46-18.46-18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.35,46.77c0,10.2,8.27,18.46,18.46,18.46,6.85,0,12.82-3.74,16.01-9.29l-16.01-9.17h-18.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 49.49,
    cy: 104.7,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 72.27,
    cy: 84.97,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 95.88,
    cy: 86.76,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 112.83,
    cy: 70.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.48,
    y1: 102.3,
    x2: 69.36,
    y2: 88.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.58,
    y1: 85.01,
    x2: 92.04,
    y2: 86.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 99.71,
    y1: 83.22,
    x2: 110.07,
    y2: 73.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.65,
    y1: 132.95,
    x2: 121.31,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.49,
    y1: 122.43,
    x2: 49.49,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 61.94,
    y1: 110.34,
    x2: 61.94,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 74.64,
    y1: 97.02,
    x2: 74.64,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 87.35,
    y1: 113.21,
    x2: 87.35,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 99.99,
    y1: 100.36,
    x2: 99.99,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 112.76,
    y1: 91.47,
    x2: 112.76,
    y2: 132.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 155.58,
    cy: 86.1,
    r: 33.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 155.58,
    cy: 86.1,
    r: 22.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "145 87.34 151.35 92.71 165.71 76.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m174.72,113.39l22.69,22.32c2.55,2.5,6.64,2.49,9.16-.04h0c2.53-2.53,2.54-6.62.03-9.16l-22.62-22.96"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo04);
export default __webpack_public_path__ + "static/media/logo04.3e5bfc143557a38d4340e243c9dfda63.svg";
export { ForwardRef as ReactComponent };